import React, { useState } from "react";
import PropTypes from "prop-types";

const Pagination = ({ totalPages, currentPage, onPageChange }) => {
    const [visibleStart, setVisibleStart] = useState(1); // Starting index of visible pages
    const visibleCount = 5; // Number of pages to show at a time

    // Calculate the visible range
    const visibleEnd = Math.min(visibleStart + visibleCount - 1, totalPages);
    const visiblePages = Array.from(
        { length: visibleEnd - visibleStart + 1 },
        (_, i) => visibleStart + i
    );

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            onPageChange(page);

            // Adjust visible range when page is at the edges
            if (page === visibleEnd && visibleEnd < totalPages) {
                setVisibleStart(visibleStart + 1);
            } else if (page === visibleStart && visibleStart > 1) {
                setVisibleStart(visibleStart - 1);
            }
        }
    };

    return (
        <nav className="flex items-center justify-center space-x-2 mt-4 flex-wrap">
            {/* Previous Button */}
            <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className={`px-3 py-1 border rounded-md transition ${currentPage === 1
                        ? "bg-gray-200 cursor-not-allowed"
                        : "bg-blue-500 text-white hover:bg-blue-600"
                    }`}
            >
                Prev
            </button>

            {visiblePages.map((page) => (
                <button
                    key={page}
                    onClick={() => handlePageChange(page)}
                    className={`px-3 py-1 border rounded-md transition ${currentPage === page
                            ? "bg-blue-500 text-white"
                            : "bg-gray-100 hover:bg-blue-100"
                        }`}
                >
                    {page}
                </button>
            ))}

            <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className={`px-3 py-1 border rounded-md transition ${currentPage === totalPages
                        ? "bg-gray-200 cursor-not-allowed"
                        : "bg-blue-500 text-white hover:bg-blue-600"
                    }`}
            >
                Next
            </button>
        </nav>
    );
};

Pagination.propTypes = {
    totalPages: PropTypes.number.isRequired,
    currentPage: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
};

export default Pagination;
